<template>
  <div class="bookdropView">
        <bookdropComp />
  </div>
</template>

<script>
import bookdropComp from '../../components/staff/bookdropComp.vue';
export default {
 components:{bookdropComp}
}
</script>

<style>

</style>